<template>
    <div class="help-index">
        <div class="panel gray-bg">
            <div class="banner-box">
                <div class="form-box">
                    <div class="text1">欢迎来到帮助中心</div>
                    <div class="text2">如有任何疑问，<br>我们随时为您解答。</div>
                    <div class="input-box">
                        <input type="text" placeholder="请搜索您遇到的问题" @keyup.enter="search" v-model="searchText">
                        <i class="fonticon icon-sousuo" @click="search"></i>
                    </div>
                </div>
                <img src="@static/images/help/01.jpg" alt="">
            </div>
        </div>
        <div class="panel white-bg">
            <div class="panel-title">问题分类</div>
            <div class="question-list">
                <div class="question-box" v-for="(item1,i) in list"  :key="i">
                    <div class="question-title" @click="goDetail(item1.itemList[0])">{{item1.title}} <span>></span></div>
                    <div class="question-item" v-for="(item2,ii) in item1.itemList" :key="ii" @click="goDetail(item2)">{{item2.title}}</div>
                </div>
            </div>
        </div>
        <div class="panel gray-bg">
            <div class="panel-title">联系我们</div>
            <div class="contact-box">
                <div class="contact-item">
                    <div class="text1">商户合作热线可拨打电话：</div>
                    <div class="text2">
                        <img src="@static/images/help/tel.png" alt="">
                        <span>{{detail.kf_tel}}</span>
                    </div>
                </div>
                <div class="contact-item contact-item2">
                    <img :src="detail.business_wx_qrcode" class="code-img">
                    <div class="contact-text">
                        <div class="text1">商务二维码</div>
                        <div class="text3">扫描微信二维码添加商务</div>
                        <div class="text3">全天24小时为您服务</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    //当前实例组件
    export default {
        data: () => ({
            list:[],
            searchText:"",
            detail:{}
        }),
        components: {},
        created() {
            this.getHelpList();
            this.getJoinData();
        },
        methods: {
            search(){
                if(this.searchText != "") {
                    this.$router.push({
                        path:'/help/search',
                        query: {
                            searchText: this.searchText,
                        }
                    })
                }
            },
            // 跳转详情
            goDetail(item){
                if(!item){
                    return;
                }
                this.$router.push({
                    path:'/help/detail',
                    query: {
                        id: item.id,
                        type: item.type
                    }
                });
            },
            // 获取客服联系数据
            getJoinData(){
                this.$http({
                    url:'/api/mp/business/joinInfo',
                    type:'get',
                    params:{}
                }).then((res)=>{
                    this.detail = res.data;
                });
            },
            // 获取问题分类
            getHelpList(){
                this.$http({
                    url:'/api/mp/helpCenter/classifyList',
                    type:'get',
                    params:{}
                }).then((res)=>{
                    this.list = res.data;
                })
            }
        },
    };
</script>
<style lang="scss">
    @import "./index.scss";
</style>
